import React from "react";
import { Box, IconButton, Stack, Typography, Avatar } from "@mui/material";
import { dummyAIModalData } from "../../dummyData";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SolidGaugeCost from "components/Charts/SolidGauge/cost";
import * as am4core from "@amcharts/amcharts4/core";
import PropTypes from "prop-types";
import { SModalBackdrop, SModalContent, SModalWrapper } from "./AIModal.styles";

am4core.addLicense("ch-custom-attribution");

const chartsCount = dummyAIModalData.constants.length;
const chartsConstants = dummyAIModalData.constants;
const chartsValues = dummyAIModalData.values;

const BuilderAIModal = ({ AIModalData, setAIModalData }) => {
  if (!AIModalData) return null;

  return (
    <SModalWrapper>
      <SModalBackdrop onClick={() => setAIModalData(null)} />
      <SModalContent>
        <IconButton
          onClick={() => setAIModalData(null)}
          sx={{ position: "absolute", top: 32, right: 32, zIndex: 1003 }}
        >
          <CloseRoundedIcon sx={{ width: 32, height: 32, color: "white" }} />
        </IconButton>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          m={6}
        >
          <Stack direction="row" alignItems="center" gap={2} p={6}>
            <Avatar size={25} src={AIModalData?.owner?.imageUrl} />
            <Typography variant="h5">
              {AIModalData?.owner?.name} {AIModalData?.owner?.surname}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            {Array.from({ length: chartsCount }).map((_, index) => {
              const constant = chartsConstants[index];
              const valuesIndex = AIModalData?.brickId
                ? AIModalData.brickId % chartsValues.length
                : 0;
              const value = chartsValues[valuesIndex][index];
              return (
                <Box width="250px" height="250px" key={index}>
                  <SolidGaugeCost
                    type={1}
                    id={`solidGauge${index + 1}`}
                    data={{
                      percentage: value,
                      labelPercentage: constant.shortLabel,
                      series: [
                        {
                          category: constant.fullLabel,
                          value,
                          full: 100,
                        },
                      ],
                    }}
                    theme={[am4core.color(constant.color)]}
                  />
                  <Typography variant="h6" sx={{ textAlign: "center" }}>
                    {constant.fullLabel}
                  </Typography>
                </Box>
              );
            })}
          </Stack>
        </Stack>
      </SModalContent>
    </SModalWrapper>
  );
};

BuilderAIModal.propTypes = {
  AIModalData: PropTypes.object,
  setAIModalData: PropTypes.func,
};

export { BuilderAIModal };
